import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["parentPermission", "childPermission"];

  connect(){
    const parentChecked = this.parentPermissionTarget.checked
    this.childPermissionTargets.map(child => {
      child.checked = !parentChecked ? false : child.checked
      if(parentChecked){
        child.removeAttribute("disabled")
      } else {
        child.setAttribute("disabled", "")
      }
    })
  }

  clickChild(event) {
    if(this.parentPermissionTarget.checked === false ) {
      event.target.checked = false
    }
  }

  clickParent(){
    const parentChecked = this.parentPermissionTarget.checked
    this.childPermissionTargets.map(child => {
      child.checked = parentChecked
      if(parentChecked){
        child.removeAttribute("disabled")
      } else {
        child.setAttribute("disabled", "")
      }
    })
  }
}
